import React from "react";
import { MetricLabel } from "../../MetricCards";
import panelStyles from "../../styles/Panel.module.css";
import analyticsStyles from "../../styles/Analytics.module.css";
import {
  formatMoney,
  formatNumber,
  formatPercent
} from "../../utils/formatters";
import { formatEntryPoint } from "../../utils/analyticsFormatters";

export function AnalyticsWeeklyBlock({ weekly }) {
  return (
    <>
      <div className={analyticsStyles.block}>
        <h3>Новые метрики (неделя)</h3>
        <div className={panelStyles.tableWrap}>
          <table className={panelStyles.table}>
            <thead>
              <tr>
                <th>Метрика</th>
                <th>Значение</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <MetricLabel title="Конверсия в оплату: подписка (новая)" hint="Пользователи + выручка + CR от новых за неделю." />
                </td>
                <td>{formatNumber(weekly.purchaseTypes.subscriptionNew.users)} / {formatMoney(weekly.purchaseTypes.subscriptionNew.revenue)} ({formatPercent(weekly.purchaseTypes.subscriptionNew.rate)})</td>
              </tr>
              <tr>
                <td>
                  <MetricLabel title="Конверсия в оплату: разовые" hint="Пользователи + выручка + CR от новых за неделю." />
                </td>
                <td>{formatNumber(weekly.purchaseTypes.oneTime.users)} / {formatMoney(weekly.purchaseTypes.oneTime.revenue)} ({formatPercent(weekly.purchaseTypes.oneTime.rate)})</td>
              </tr>
              <tr>
                <td>
                  <MetricLabel title="Разовые → подписка (7 дней)" hint="Доля разовых покупателей, купивших подписку за 7 дней." />
                </td>
                <td>{formatNumber(weekly.oneTimeToSubscription.converted7)} ({formatPercent(weekly.oneTimeToSubscription.rate7)})</td>
              </tr>
              <tr>
                <td>
                  <MetricLabel title="Разовые → подписка (30 дней)" hint="Доля разовых покупателей, купивших подписку за 30 дней." />
                </td>
                <td>{formatNumber(weekly.oneTimeToSubscription.converted30)} ({formatPercent(weekly.oneTimeToSubscription.rate30)})</td>
              </tr>
              <tr>
                <td>
                  <MetricLabel title="Подписки (неделя): новые / продления" hint="Количество уникальных пользователей." />
                </td>
                <td>{formatNumber(weekly.subscriptions.new.users)} / {formatNumber(weekly.subscriptions.renewals.users)}</td>
              </tr>
              <tr>
                <td>
                  <MetricLabel title="Подписки (неделя): отмены / чистый прирост" hint="Отмены считаются только по реальным cancellation-событиям, payment_fail показывается отдельно в блоке денег." />
                </td>
                <td>{formatNumber(weekly.subscriptions.cancellations)} / {formatNumber(weekly.subscriptions.net)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className={analyticsStyles.block}>
        <h3>Подписки по тарифам (неделя)</h3>
        {weekly.subscriptions?.byTariff?.length ? (
          <div className={panelStyles.tableWrap}>
            <table className={panelStyles.table}>
              <thead>
                <tr>
                  <th>Тариф</th>
                  <th>Пользователи</th>
                  <th>Пользователи (новые)</th>
                  <th>Пользователи (продления)</th>
                  <th>Покупок</th>
                  <th>Выручка</th>
                </tr>
              </thead>
              <tbody>
                {weekly.subscriptions.byTariff.map((row, index) => (
                  <tr key={`sub-tariff-${row.tariffId}-${index}`}>
                    <td>{row.title || `#${row.tariffId}`}</td>
                    <td>{formatNumber(row.users)}</td>
                    <td>{formatNumber(row.usersNew)}</td>
                    <td>{formatNumber(row.usersRenew)}</td>
                    <td>{formatNumber(row.events)}</td>
                    <td>{formatMoney(row.revenue)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className={panelStyles.note}>Нет данных по тарифам подписок за неделю.</div>
        )}
      </div>

      <div className={analyticsStyles.block}>
        <h3>Entry point в оплате (неделя)</h3>
        {weekly.entryPoints?.rows?.length ? (
          <div className={panelStyles.tableWrap}>
            <table className={panelStyles.table}>
              <thead>
                <tr>
                  <th>Точка входа</th>
                  <th>Пользователи paywall</th>
                  <th>Покупатели</th>
                  <th>Конверсия paywall→покупка</th>
                  <th>Покупок</th>
                  <th>Выручка</th>
                  <th>Средний чек</th>
                </tr>
              </thead>
              <tbody>
                {weekly.entryPoints.rows.map((row, index) => (
                  <tr key={`entry-${row.entryPoint || "unknown"}-${index}`}>
                    <td>{formatEntryPoint(row.entryPoint)}</td>
                    <td>{formatNumber(row.paywallUsers)}</td>
                    <td>{formatNumber(row.purchaseUsers)}</td>
                    <td>{formatPercent(row.conversion)}</td>
                    <td>{formatNumber(row.purchases)}</td>
                    <td>{formatMoney(row.revenue)}</td>
                    <td>{formatMoney(row.avgCheck)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className={panelStyles.note}>Нет данных по entry_point.</div>
        )}
      </div>

      <div className={analyticsStyles.block}>
        <h3>Роли и оплата (неделя)</h3>
        <div className={panelStyles.tableWrap}>
          <table className={panelStyles.table}>
            <thead>
              <tr>
                <th>Роль</th>
                <th>Платящие (шт / %)</th>
                <th>Выручка подписки</th>
                <th>Выручка разовые</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Школьники</td>
                <td>{formatNumber(weekly.roles.school.payers)} ({formatPercent(weekly.roles.school.payRate)})</td>
                <td>{formatMoney(weekly.roles.school.subsRevenue)}</td>
                <td>{formatMoney(weekly.roles.school.oneTimeRevenue)}</td>
              </tr>
              <tr>
                <td>Другое</td>
                <td>{formatNumber(weekly.roles.other.payers)} ({formatPercent(weekly.roles.other.payRate)})</td>
                <td>{formatMoney(weekly.roles.other.subsRevenue)}</td>
                <td>{formatMoney(weekly.roles.other.oneTimeRevenue)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default AnalyticsWeeklyBlock;
